import {useState, type Ref} from '#imports';

export type DataLayer = {
    name?: string;
    profileId?: string;
    identityIds?: string[];
    created_at?: string;
    user_id?: string;
    identityId?: string;
    identityType?: string;
    user_hash?: string;
    admin?: string;
    loggedUser?: string;
    visitorCategories?: string[];
    flag?: string[];
    clientMaturity?: string;
    freelanceMaturity?: string;
    freelanceCategory?: string;
    freelanceExperienceLevel?: string;
    compliant?: string;
    scoring?: string;
    favorite?: string;
    tiering?: string;
    managerId?: string;
    firstCreatedConversationId?: string;
    lastCreatedConversationId?: string;
    lastConversationDate?: string;
    lastMissionDate?: string;
    lastQuoteDate?: string;
    clientPricingPlanType?: string;
    companyCreationDate?: string;
    correlationId?: string;
    maltSessionId?: string;
    maltVisitorId?: string;
    serviceLevel?: string;
    abtastyCampaigns?: string[];
    abtastyVariations?: string[];
    abtestCampaigns?: string[];
    abtestVariations?: string[];
};

export function useDataLayer(): Ref<DataLayer> {
    return useState<DataLayer>('dataLayer', () => ({}));
}
